import React, { useState } from "react";
import { Card, Table } from "reactstrap";

const CustomerUserActions = (props) => {
  const { customerId } = props;
  const [userActionsArray, setUserActionsArray] = useState([-1]);

  const loadUserActions = () => {
    if (Array.isArray(userActionsArray) && userActionsArray[0] == -1) {
      fetch("/api/customer/fetch-user-actions/" + customerId)
        .then(res => res.json())
        .then(res => setUserActionsArray(res));
    }
  };

  loadUserActions();

  return (
    <Card className="p-2 mt-1">
      {
        userActionsArray.length === 0 || userActionsArray[0] === -1 ?
        (<span>No user actions logged for this client.</span>) :
        (
          <div>
            <span>Actions Logged: </span>
            <Table className="table=sm mt-2">
              <tbody>
                {userActionsArray.slice(0, 30).map((userAction) => (
                  <tr>
                    <td className="text-left">
                      {userAction.user?.personal?.name}
                      &nbsp;
                      {userAction.actionName}
                    </td>
                    <td className="text-left">API used: {userAction.apiUsed}</td>
                    <td className="text-left">{new Date(userAction.createdOn).toUTCString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )
      }
    </Card>
  );
};

export default CustomerUserActions;
